import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./features/auth/authSlice";
import { employerSlice } from "./features/employer/employerSlice";
import { candidateSlice } from "./features/candidate/candidateSlice";
import { chatSlice } from "./features/chat/chatSlice";
import { ptmAccountSlice } from "./features/ptmAccounts/ptmAccountSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    employer: employerSlice.reducer,
    candidate: candidateSlice.reducer,
    chat: chatSlice.reducer,
    ptmAccounts: ptmAccountSlice.reducer,
  },
});
